import React from 'react'
import { withIcon } from '../../withIcon'

function PinnedFilledIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M12.0462 2C9.27311 2 8 2.82182 8 3.42857C8 4.03533 8.4301 5.12069 9 5.80952C9.34181 6.22267 10 6.7619 10 6.7619L9.5 10.0952C9.5 10.0952 6.5 11.4651 6.5 13.2332C6.50001 16.1148 11.5 16.2857 11.5 16.2857L12 22L12.5 16.2857C12.5 16.2857 17.5 16.0904 17.5 13.2332C17.5 11.459 14.5 10.0952 14.5 10.0952L14 6.7619C14 6.7619 14.6672 6.22928 15 5.80952C15.6336 5.01033 16 4.03907 16 3.42857C16 2.81807 14.8193 2 12.0462 2Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PinnedFilledIcon)
